// extracted by mini-css-extract-plugin
export var logo = "_50-2";
export var logoWrapper = "_50-1";
export var strip = "_50-0";